import { ISO_639_1_LOCALE, ISO_639_3_LOCALE, LOCALE_MAPPING } from './locale-helper';

interface TranslationObject {
    [key: string]: string;
}

export function getTranslationWithFallback(
    translations: TranslationObject,
    requestedLocale: string,
    fallbackText?: string
): string {
    // 1. Try requested language
    if (translations?.[requestedLocale]?.trim()) {
        return translations[requestedLocale];
    }

    // 2. Try first existing translation (sort alphabetically for consistency)
    const availableTranslations = Object.entries(translations || {})
        .filter(([, value]) => value?.trim())
        .sort(([a], [b]) => a.localeCompare(b));

    if (availableTranslations.length > 0) {
        return availableTranslations[0][1];
    }

    return fallbackText || '';
}

// Helper for locale to ISO_639_3_Locale mapping (e.g. 'de' or 'de-CH' -> 'gsw')
export function getLocaleCode(locale: string): ISO_639_3_LOCALE {
    // Handle special cases like 'de-CH' -> 'gsw'
    const specialCases: Record<string, ISO_639_3_LOCALE> = {
        'de-CH': 'gsw'
    };

    if (specialCases[locale]) {
        return specialCases[locale];
    }

    // Extract language code (first 2 chars)
    const languageCode = locale.substring(0, 2) as ISO_639_1_LOCALE;

    // Dynamisch: Search existing LOCALE_MAPPING to find ISO_639_3 Code
    for (const [iso3Code, iso1Code] of Object.entries(LOCALE_MAPPING)) {
        if (iso1Code === languageCode) {
            return iso3Code as ISO_639_3_LOCALE;
        }
    }

    return 'deu'; // Fallback
}
